// Port of webapp/src/components/sidebar/sidebarCategory.tsx

import {ReactElement} from 'react'
import {CategoryBoards} from '../../types/category'
import {Board} from '../../types/board'
import {BoardView} from '../../types/boardView'
import {Icon} from '../common/icons'
import SidebarBoardItem from './sidebarBoardItem'

type Props = {
    category: CategoryBoards
    boards: Board[]
    viewsByBoard: Record<string, BoardView[]>
    activeBoardId: string
    activeViewId: string | undefined
    teamId: string
    readOnly: boolean
    onToggleCollapsed: (categoryId: string) => void
}

export default function SidebarCategory(props: Props): ReactElement {
    const {category, boards, viewsByBoard, activeBoardId, activeViewId, teamId, readOnly, onToggleCollapsed} = props

    const items = category.boardMetadata.
        filter((metadata) => !metadata.hidden).
        map((metadata) => boards.find((b) => b.id === metadata.boardID)).
        filter((board): board is Board => Boolean(board) && board!.deleteAt === 0)

    return (
        <div className='SidebarCategory mb-1'>
            <button
                type='button'
                onClick={() => onToggleCollapsed(category.id)}
                className='flex h-[26px] w-full items-center gap-1 px-2 text-left text-xs font-semibold uppercase tracking-wide text-sidebar-fg/60 hover:text-sidebar-fg'
                aria-expanded={!category.collapsed}
            >
                <Icon name={category.collapsed ? 'chevron-right' : 'chevron-down'} size={12}/>
                <span className='truncate'>{category.name}</span>
                <span className='ml-auto opacity-60'>{items.length}</span>
            </button>

            {!category.collapsed && (
                items.length ? (
                    <div className='octo-sidebar-list'>
                        {items.map((board) => (
                            <SidebarBoardItem
                                key={board.id}
                                board={board}
                                views={viewsByBoard[board.id] || []}
                                activeBoardId={activeBoardId}
                                activeViewId={activeViewId}
                                teamId={teamId}
                                readOnly={readOnly}
                            />
                        ))}
                    </div>
                ) : (
                    <div className='py-1 pl-7 text-xs text-sidebar-fg/40'>该分组下暂无看板</div>
                )
            )}
        </div>
    )
}
